import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SavedBuildingPermits } from '../../../SavedBuildingPermits'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

/**
 * Shared BuildingPermitsTab for read-only display of saved building permits.
 * Used by all 3 public page types (land, building, estimate).
 * Renders SavedBuildingPermits from pre-fetched entity data.
 */
export const BuildingPermitsTab: React.FC = () => {
  const { t } = useTranslation('common')
  const { entity } = useAnalysisMode()
  const { setActiveSection, updateSectionData } = useAnalysisMapSectionData()

  // Extract saved building permits from entity
  const savedPermits = useMemo(() => {
    const permitsData =
      entity?.saved_building_permits || entity?.savedBuildingPermits || []
    return Array.isArray(permitsData) ? permitsData : []
  }, [entity])

  // Push building permits data to map context
  useEffect(() => {
    setActiveSection('building_permits')
    if (savedPermits.length > 0) {
      updateSectionData({ building_permits: savedPermits })
    }
  }, [savedPermits, setActiveSection, updateSectionData])

  // Handle permit click (no-op in read-only mode)
  const handlePermitClick = () => {
    // In read-only mode, we don't have permit detail panels
  }

  return (
    <SavedBuildingPermits
      permits={savedPermits}
      onPermitClick={handlePermitClick}
      isLoading={false}
      t={t}
    />
  )
}
